// extracted by mini-css-extract-plugin
module.exports = {"incut":"incut-link_incut__WV4oz","incut__image":"incut-link_incut__image__4JTrp","incut__text":"incut-link_incut__text__gv6Fn"};